import { adminGetProjectFilesDowloadUrl } from '@utils/api';
import pLimit from 'p-limit';

// Resolves/rejects with the same message strings as before; written as a plain async
// function because an async Promise executor swallows errors thrown before resolve/reject.
export const downloadProjectFiles = async (project_uuid, path = 'images/') => {
	const limit = pLimit(5);
	let fileEntries;
	try {
		fileEntries = Object.entries(await adminGetProjectFilesDowloadUrl(project_uuid, path));

		if (fileEntries.length) {
			const promises = [];
			for (const [key, url] of fileEntries)
				promises.push(limit(async () => downloadFile(key, url)));

			await Promise.all(promises);
			return 'All images downloaded successfully.';
		}
	} catch (error) {
		limit.clearQueue();
		console.error(error);
		throw 'Something went wrong while downloading the images. Check the console for more details.';
	}

	throw `No images to download found in s3 bucket: ${path}`;
};

export const downloadFile = async (key, signed_url) => {
	const fileName = key.split('/').pop();
	console.log('%c⬇️ Downloading: ', 'color: #EABDC4', fileName);

	try {
		const response = await fetch(signed_url);
		if (!response.ok) throw new Error('Network response was not ok');

		const blob = await response.blob();
		const a = document.createElement('a');
		const url = URL.createObjectURL(blob);
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
		a.remove();

		return `Downloaded ${fileName}`;
	} catch (error) {
		console.error(error);
		throw `Failed to download file ${fileName}. Check the console for more information.`;
	}
};
